import { defineMessages } from 'react-intl';

export const sourceGroundedMessages = defineMessages({
  sourcesHeading: {
    defaultMessage: 'Sources ({count})',
    id: 'dDlLVy5Evv',
    description: 'Footer heading above source-grounded reference chips',
  },
  noteTitle: {
    defaultMessage: 'Note',
    id: 'ql2ZvAi77F',
    description: 'Compact citation title for a consult note source',
  },
  titleDetailTitle: {
    defaultMessage: '{label} — {detail}',
    id: 'lpVgRTZYfj',
    description: 'Tooltip for a source reference with label and detail',
  },
  titleSubtitleTitle: {
    defaultMessage: '{title} · {subtitle}',
    id: 'PzFNlMQ1pr',
    description: 'Tooltip for a source reference with title and subtitle',
  },
  openSourceAria: {
    defaultMessage: 'Open source {id}: {title}',
    id: 'OX3OC+Ry5q',
    description: 'Accessible label for a navigable source reference chip',
  },
  jumpToSourceAria: {
    defaultMessage: 'Jump to source {id}: {title}',
    id: '8eH0dkBs36',
    description: 'Accessible label for an in-page source reference chip',
  },
  openSource: {
    defaultMessage: 'Open source',
    id: 'ZPTeAD6o1K',
    description: 'Button to open a source citation in its artifact panel',
  },
  sourcesAria: {
    defaultMessage: 'Sources {ids}: {labels}',
    id: 'poyUzEdkOj',
    description: 'Accessible label for a multi-source citation chip',
  },
  sourceAria: {
    defaultMessage: 'Source {id}: {label}',
    id: '+tf3JUWZ1c',
    description: 'Accessible label for a single-source citation chip',
  },
  compactCitation: {
    defaultMessage: '[{ids}]',
    id: 'NTNbs48BSy',
    description: 'Compact inline citation chip showing source indices',
  },
  extraSources: {
    defaultMessage: '+{count}',
    id: 'yD8d98kszQ',
    description: 'Overflow count on a multi-source citation chip',
  },
});
